module.exports = __webpack_public_path__ + "img/sbw.48cf503f.jpg";